export function isNotNull(v) {
  return v !== null && v !== undefined
}